import { render, staticRenderFns } from "./MedicsReport.vue?vue&type=template&id=b3454782&scoped=true&"
import script from "./MedicsReport.vue?vue&type=script&lang=js&"
export * from "./MedicsReport.vue?vue&type=script&lang=js&"
import style0 from "./MedicsReport.vue?vue&type=style&index=0&id=b3454782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3454782",
  null
  
)

export default component.exports